<template>
  <div
    :class="tabActiveClass"
    id="bank"
    role="tabpanel"
    aria-labelledby="bank-tab"
  >
    <h4 class="form-title hide-mobile">{{ transPeralbaPro.item843 }}</h4>
    <hr class="hide-mobile" />
    <div class="row">
      <div class="col-md-6">
        <h5 class="form-subtitle">{{ transPeralbaPro.item869 }}</h5>
        <p class="form-subtitle-p">{{ transPeralbaPro.item870 }}</p>
      </div>
      <div class="col-md-6">
        <form-input
          fieldName="nombreContactoBanco"
          :fieldLabel="transPeralbaPro.item871"
          fieldType="text"
          :fieldValue="nombreContactoBanco"
          :inputPlaceholder="transPeralbaPro.item871"
          :is-required="true"
          :has-error="fieldHasErrors('bankingData', 'nombreContactoBanco')"
          @updateValue="updateFormValue"
        />
        <form-radio-button
          :fieldValue="selectedElectronicInvoicing"
          fieldName="selectedElectronicInvoicing"
          :fieldLabel="transPeralbaPro.item872"
          :items="[
            { id: 0, name: 'No' },
            { id: 1, name: 'Si' },
          ]"
          :is-required="true"
          :has-error="
            fieldHasErrors('bankingData', 'selectedElectronicInvoicing')
          "
          @updateValue="updateFormValue"
        />

        <form-input
          v-if="selectedElectronicInvoicing == 1"
          fieldName="emailInvoicing"
          :fieldLabel="transPeralbaPro.item873"
          fieldType="email"
          :fieldValue="emailInvoicing"
          :inputPlaceholder="transPeralbaPro.item794"
          :is-required="true"
          :has-error="fieldHasErrors('bankingData', 'emailInvoicing')"
          @updateValue="updateFormValue"
        />
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <h5 class="form-subtitle">{{ transPeralbaPro.item629 }}</h5>
        <p class="form-subtitle-p">{{ transPeralbaPro.item874 }}</p>
      </div>
      <div class="col-md-6">
        <form-radio-button
          :fieldValue="selectedPaymentMethod"
          fieldName="selectedPaymentMethod"
          :fieldLabel="transPeralbaPro.item101"
          :items="paymentMethods"
          :is-required="true"
          :has-error="fieldHasErrors('bankingData', 'selectedPaymentMethod')"
          @updateValue="updateFormValue"
        />

        <form-input
          v-if="selectedPaymentMethod != 1"
          fieldName="iban"
          :fieldLabel="transPeralbaPro.item875"
          fieldType="text"
          :fieldValue="iban"
          :inputPlaceholder="transPeralbaPro.item875"
          @updateValue="updateFormValue"
          :is-required="true"
          :has-error="fieldHasErrors('bankingData', 'iban')"
          :tooltip-info="transPeralbaPro.item876"
        />

        <form-input
          v-if="selectedPaymentMethod != 1"
          fieldName="nombreBanco"
          :fieldLabel="transPeralbaPro.item877"
          fieldType="text"
          :fieldValue="nombreBanco"
          :inputPlaceholder="transPeralbaPro.item877"
          :is-required="true"
          :has-error="fieldHasErrors('bankingData', 'nombreBanco')"
          @updateValue="updateFormValue"
        />

        <form-input
          v-if="selectedPaymentMethod != 1"
          fieldName="swift"
          :fieldLabel="transPeralbaPro.item878"
          fieldType="text"
          :fieldValue="swift"
          :inputPlaceholder="transPeralbaPro.item878"
          :is-required="true"
          :has-error="fieldHasErrors('bankingData', 'swift')"
          @updateValue="updateFormValue"
        />

        <form-check-box
          v-if="selectedPaymentMethod != 1"
          :fieldValue="sepa"
          fieldName="sepa"
          :fieldLabel="sepaText"
          :is-required="selectedPaymentMethod != 1 ? true : false"
          :has-error="fieldHasErrors('bankingData', 'sepa')"
          @updateValue="updateFormValue"
        />

        <vue-dropzone
          v-if="selectedPaymentMethod != 1"
          ref="myVueDropzone"
          id="dropzone"
          :options="dropzoneOptions"
          @vdropzone-success="uploadDropzoneFinish"
          @vdropzone-removed-file="uploadDropzoneFinish"
        ></vue-dropzone>
      </div>
    </div>

    <div class="w-100" style="height: 100px">
      <button
        type="button"
        :disabled="disabledForm"
        class="btn-per-dark-outlined mt-4 mb-2"
        @click="$emit('goToDatosComerciales')"
        style="float: left"
      >
        <i class="fas fa-arrow-left me-3"></i>{{ transPeralbaPro.item833 }}
      </button>
      <button
        type="button"
        :disabled="disabledForm"
        class="btn-per-dark mt-4 mb-2"
        @click="$emit('validateRegisterBankingData')"
        style="float: right"
      >
        {{ transPeralbaPro.item827 }}<i class="fas fa-arrow-right ms-3"></i>
      </button>
    </div>
  </div>
</template>
<script>
import FormInput from "../../../../../components/front/Inputs/FormInput";
import FormRadioButton from "../../../../../components/front/Inputs/FormRadioButton";
import FormCheckBox from "../../../../../components/front/Inputs/FormCheckBox";
import sections from "../../mixins/sections";
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";

export default {
  mixins: [sections],
  components: {
    FormInput,
    FormRadioButton,
    FormCheckBox,
    vueDropzone: vue2Dropzone,
  },
  props: [
    "activeTab",
    "nombreContactoBanco",
    "selectedElectronicInvoicing",
    "emailInvoicing",
    "iban",
    "nombreBanco",
    "swift",
    "selectedPaymentMethod",
    "sepa",
    "paymentMethods",
    "disabledForm",
    "routePrivacy",
    "routeLegal",
    "routeSepa",
    "errors",
    "transPeralbaPro",
  ],
  data() {
    return {
      dropzoneOptions: {
        url: "http://peralba.com",
        thumbnailWidth: 150,
        maxFilesize: 0.5,
        headers: { "My-Awesome-Header": "header value" },
      },
    };
  },
  methods: {
    uploadDropzoneFinish(file) {
      this.$emit("handleDropzone", file);
    },
  },
  computed: {
    sepaText() {
      return (
        this.transPeralbaPro.item1005 +
        `<a href="${this.routeSepa}" target="_blank">` +
        this.transPeralbaPro.item1006 +
        `</a> `
      );
    },
  },
};
</script>
